import Request from './request'

const TarifficationBlockedSimcard  = {
  getTarifficationBlockedSimcardList(params, callback, bad_answer) {
    Request.get('tariffication-blocked-simcard', params).then(callback).catch(bad_answer)
  },
  getTarifficationBlockedSimcardInfo(id, callback) {
    Request.get('tariffication-blocked-simcard/' + id).then(callback).catch(this.bad_answer)
  },
  updateBlockedSimcard(id, params, callback) {
    Request.put('tariffication-blocked-simcard/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getBlockedSimcardDevices(fid, callback){
    Request.get('tariffication-blocked-simcard/device/' + fid).then(callback).catch(this.bad_answer)
  },
  addBlockedSimcardDevices(params, callback){
    Request.post('tariffication-blocked-simcard', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  }

}

export default TarifficationBlockedSimcard
